/**
 * A short two-tone notification "ping" for incoming chat messages,
 * synthesized with the Web Audio API rather than a bundled audio file --
 * no asset to ship, and it's a two-line function. Muting is a simple
 * persisted preference (see utils/preferences.js) that every call site
 * checks itself, so App.js's background poll and the chat panel's own
 * mute toggle just read/write the same localStorage-backed flag without
 * needing to share any React state.
 */
import { getPref, setPref, PREF_KEYS } from './preferences';

export const isChatSoundMuted = () => getPref(PREF_KEYS.CHAT_SOUND_MUTED, false);

export const setChatSoundMuted = (muted) => setPref(PREF_KEYS.CHAT_SOUND_MUTED, muted);

let audioCtx = null;

export const playNotificationSound = () => {
  if (isChatSoundMuted()) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    audioCtx = audioCtx || new Ctx();
    if (audioCtx.state === 'suspended') audioCtx.resume();

    const now = audioCtx.currentTime;
    const playTone = (freq, start, duration) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(0.18, now + start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.start(now + start);
      osc.stop(now + start + duration + 0.02);
    };
    playTone(880, 0, 0.11);
    playTone(1175, 0.12, 0.13);
  } catch (e) {
    // Web Audio blocked/unavailable -- the toast and tab-blink still cover it.
  }
};
